import { Link, useLocation } from 'react-router-dom'

const navItems = [
  { path: '/', label: 'Home', icon: 'home' },
  { path: '/history', label: 'History', icon: 'history' },
  { path: '/insights', label: 'Insights', icon: 'insights' },
  { path: '/settings', label: 'Settings', icon: 'settings' },
]

async function handleShare() {
  const shareData = {
    title: 'PresentLens',
    text: 'Reframe your thoughts with AI-powered cognitive tools',
    url: 'https://presentlens.app',
  }

  if (navigator.share) {
    try {
      await navigator.share(shareData)
    } catch (err) {
      // User cancelled or share failed silently
    }
  } else {
    // Fallback: copy link to clipboard
    try {
      await navigator.clipboard.writeText(shareData.url)
      alert('Link copied to clipboard!')
    } catch {
      // Fallback for older browsers
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareData.text)}&url=${encodeURIComponent(shareData.url)}`, '_blank')
    }
  }
}

export function Nav() {
  const location = useLocation()

  return (
    <div className="nav-wrapper">
      <div className="nav-footer">
        <button onClick={handleShare} className="share-btn" aria-label="Share PresentLens">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="18" cy="5" r="3"/>
            <circle cx="6" cy="12" r="3"/>
            <circle cx="18" cy="19" r="3"/>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
          </svg>
          Share
        </button>
        <a href="https://northcoast.ai" target="_blank" rel="noopener noreferrer" className="attribution">
          brought to you by <span>northcoast.ai</span>
        </a>
      </div>
      <nav className="nav">
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            {item.label}
          </Link>
        ))}
      </nav>
    </div>
  )
}
